import PropTypes from 'prop-types';
import React from 'react';
import QuestionErrors from './QuestionErrors';
import QuestionMeta from './AsyncQuestionMeta';
import SingleWhy from './SingleWhy';
import SurveyAttachment from '../attachment/SurveyAttachment';
import classnames from 'classnames';
import logError from '../../../utils/logError';
import SurveyIcon from '../SurveyIcon';

class QuestionWrapper extends React.PureComponent {
  render() {
    const {
      add_why,
      children,
      showQuestionMeta,
      text,
      thumbSize,
      ...props
    } = this.props;
    return (
      <li className={questionClassNames(props)} id={`question_${props.id}`}>
        {showQuestionMeta && <QuestionMeta {...props} />}
        <SurveyAttachment
          id={props.id}
          size={thumbSize}
          test={
            props._type !== 'Survey::HeatMap' &&
            props._type !== 'Survey::TimedHeatMap' &&
            props._type !== 'Survey::StickyNote' &&
            props._type !== 'Survey::Timed'
          }
        />
        {(props.requiredIndicator && props.required) ? (
          <SurveyIcon
            icon="asterisk"
            className="float-left c-ccc"
            height="16"
            width="16"
            style={{
              marginLeft: '-1.5rem',
              marginTop: '0.3rem',
            }}
          />
        ) : null}
        <label
          className="fs-18 lh-copy d-b mb3 cursor-text srv-q-t desc-vert-rhythm"
          dangerouslySetInnerHTML={{ __html: text }}
        />
        <ErrorBoundary>{children}</ErrorBoundary>
        <QuestionErrors questionId={props.id} />
        {!props.matrix && <SingleWhy add_why={add_why} {...props} />}
        {props.appendedChildren}
      </li>
    );
  }
}

QuestionWrapper.propTypes = {
  _type: PropTypes.string,
  add_why: PropTypes.bool,
  appendedChildren: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  matrix: PropTypes.bool,
  showQuestionMeta: PropTypes.bool,
  text: PropTypes.string,
  thumbSize: PropTypes.string,
};

export default QuestionWrapper;

//

const questionClassNames = (
  { className, field_type, kind, overview, required, _type },
  extra
) =>
  classnames(className, extra, kind, field_type, _type, {
    'mv0 p4 bb b--ddd': true,
    'clearfix srv_ovw': overview,
    required,
  });

class ErrorBoundary extends React.Component {
  state = { hasError: false };

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    logError(error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="rounded bc-light_gray d-flex jc-center align-center ta-c border-box p5 bt bw1 b--red"
          style={{ height: '16rem' }}
        >
          <div>
            <p className="mv0 fs-14">This survey question failed to load.</p>
            <p className="mv0 fs-12 c-black-50">
              We've been notified and the issue will be fixed. Please continue
              to take the survey, or reload the page to try again.
            </p>
          </div>
        </div>
      );
    }
    return this.props.children || null;
  }
}

ErrorBoundary.propTypes = { children: PropTypes.node };
